<template>
  <div class="register-form">
    <v-row no-gutters>
      <v-col>
        <v-card class="rounde-lg">
          <v-card-text class="pb-0">
            <v-row no-gutters class="d-flex justify-center text-center">
              <v-col cols="12" class="d-flex justify-center">
                <a @click="onCancel" :title="$t('voltar_pagina_principal')">
                  <v-img
                    content-class="d-flex"
                    :src="getLogo(2) || $store.state.imgLogoDefault"
                    max-width="180"
                  />
                </a>
              </v-col>
              <v-col cols="5" class="pa-2 pb-3">
                <v-divider></v-divider>
              </v-col>
              <v-col cols="12" class="d-flex flex-column align-center">
                <h1 class="title">{{ $t("cadastro") }}</h1>
                <v-col cols="8" class="ma-0">
                  <small>{{ formDesc }}</small>
                </v-col>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-text class="pt-0">
            <ValidationObserver ref="observer" v-slot="{ invalid }">
              <v-form @submit.prevent.stop="onSubmit">
                <validation-provider
                  v-slot="{ errors }"
                  name="idioma"
                  rules="required"
                >
                  <v-select
                    v-model="form.idioma"
                    :items="$store.state.languages"
                    item-text="lang"
                    item-value="flag"
                    name="idioma"
                    :label="$t('idioma')"
                    prepend-icon="mdi-earth"
                    @change="onChangeLanguage"
                    required
                    :error-messages="errors"
                    :readonly="showLoading"
                  >
                    <template #prepend>
                      <v-layout align-center class="mt-1">
                        <v-icon v-if="!form.idioma">mdi-earth</v-icon>
                        <v-img
                          v-else
                          width="20"
                          :src="'/lang/flags/' + form.idioma + '.svg'"
                        />
                      </v-layout>
                    </template>
                    <template #item="{ item }">
                      <v-layout justify-start align-center>
                        <div class="pr-3">
                          <v-img
                            width="20"
                            :src="'/lang/flags/' + item.flag + '.svg'"
                          />
                        </div>
                        <div>
                          <small>{{ item.lang }}</small>
                        </div>
                      </v-layout>
                    </template>
                  </v-select>
                </validation-provider>
                <validation-provider
                  v-slot="{ errors }"
                  name="email"
                  rules="required|email"
                >
                  <v-text-field
                    v-model="form.email"
                    type="email"
                    :label="$t('email')"
                    prepend-icon="mdi-at"
                    autocomplete="off"
                    required
                    :error-messages="errors"
                    :readonly="showLoading"
                  />
                </validation-provider>
                <validation-provider
                  v-slot="{ errors }"
                  name="celular"
                  :rules="{
                    required: true,
                  }"
                >
                  <v-text-field
                    v-model="form.celular"
                    v-mask="getPhoneMask"
                    type="tel"
                    :label="$t('celular')"
                    prepend-icon="mdi-phone"
                    autocomplete="off"
                    required
                    :error-messages="errors"
                    :readonly="showLoading"
                    inputmode="numeric"
                  />
                </validation-provider>
                <validation-provider
                  v-slot="{ errors }"
                  name="password"
                  rules="required|password:8"
                >
                  <v-text-field
                    v-model="form.password"
                    :label="$t('senha')"
                    prepend-icon="mdi-key-variant"
                    autocomplete="new-password"
                    required
                    :error-messages="errors"
                    :readonly="showLoading"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="showPassword ? 'text' : 'password'"
                    class="mt-3"
                    @click:append="showPassword = !showPassword"
                    @keypress="$refs.observer.validate()"
                  />
                </validation-provider>
                <div class="controlls d-flex flex-column centerify mt-4">
                  <div>
                    <v-checkbox dense v-model="terms">
                      <template #label>
                        <div class="caption">
                          {{ $t("li_aceito_o") }}
                          <a
                            target="_self"
                            href="#"
                            @click.stop="showModalPrivacy = true"
                          >
                            {{ $t("termo_privacidade") }}
                          </a>
                          <v-dialog v-model="showModalPrivacy">
                            <v-card>
                              <v-layout
                                justify-end
                                class="pa-3"
                                style="position: fixed; right: 10px; top: 30px"
                              >
                                <v-btn
                                  color="grey"
                                  rounded
                                  text
                                  @click="showModalPrivacy = false"
                                >
                                  <v-icon size="36">mdi-close</v-icon>
                                </v-btn>
                              </v-layout>
                              <v-card-text>
                                <privacy-policy />
                              </v-card-text>
                            </v-card>
                          </v-dialog>
                        </div>
                      </template>
                    </v-checkbox>
                    <v-checkbox dense v-model="accept">
                      <template #label>
                        <span class="caption">
                          {{ $t("aceito_receber_promocoes") }}
                        </span>
                      </template>
                    </v-checkbox>
                  </div>
                  <v-btn
                    v-if="!showLoading"
                    type="submit"
                    color="primary"
                    :disabled="invalid || !terms"
                    class="mt-6 px-6"
                  >
                    {{ $t("cadastrar") }}
                  </v-btn>
                  <div v-else class="d-flex centerify flex-column">
                    <v-progress-circular
                      :width="2"
                      size="20"
                      color="primary"
                      indeterminate
                      class="mb-3"
                    />
                    <div>{{ $t("cadastrando") }}</div>
                  </div>
                </div>
              </v-form>
            </ValidationObserver>
          </v-card-text>
        </v-card>
        <v-alert
          color="red"
          outlined
          dark
          type="error"
          :value="showError"
          transition="scroll-y-reverse-transition"
          class="alert-error py-3 mt-3"
          style="position: absolute; bottom: 0; z-index: 3"
          @click="showError = false"
        >
          {{ errorMessage }}
        </v-alert>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { required, email, regex, min } from "vee-validate/dist/rules";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";
import PrivacyPolicy from "@/components/modals/privacy-policy";

setInteractionMode("eager");

export default {
  components: {
    PrivacyPolicy,
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    onRequest: {
      type: Function,
      default: async () => {},
    },
    onResponse: {
      type: Function,
      default: async () => {},
    },
    onCancel: {
      type: Function,
      default: async () => {},
    },
    formDesc: {
      type: String,
    },
    imgLogo: {
      type: String,
    },
  },
  data: () => ({
    showError: false,
    showLoading: false,
    showPassword: false,
    showModalPrivacy: false,
    terms: false,
    accept: false,
    errorMessage: "",
  }),
  computed: {
    getLogo() {
      return (num) => {
        return !this.imgLogo ? null : this.imgLogo + "/logo_" + num + ".jpg";
      };
    },
    form() {
      return this.$store.state.register;
    },
    getPhoneMask() {
      return this.$store.state.language === "pt_br"
        ? ["(##) #####-####", "(##) ####-####"]
        : this.$store.state.language === "it"
        ? ["### ## ## ##", "### ## ## ###"]
        : ["### ### ####"];
    },
  },
  methods: {
    async onSubmit() {
      this.$refs.observer.validate();

      this.showLoading = true;

      this.showError = false;

      const response = await this.onRequest({
        ...this.form,
        terms: this.terms,
        accept: this.accept,
      });

      this.showLoading = false;

      this.onResponse(
        response,
        (error) => {
          this.showError = true;
          this.errorMessage = error;

          const time = setTimeout(() => {
            clearTimeout(time);
            this.showError = false;
          }, 3000);
        },
        this.form
      );
    },
    onChangeLanguage(lang) {
      this.$store.commit("setLanguage", lang);
    },
  },
  updated() {
    extend("email", {
      ...email,
      message: this.$t("email_invalido"),
    });

    extend("password", {
      ...min,
      message: this.$t("senha_deve_ter_8_digitos"),
    });

    extend("celular", {
      ...regex,
      message: this.$t("celular_invalido"),
    });

    extend("required", {
      ...required,
      message: this.$t("obrigatorio"),
    });
  },
};
</script>

<style lang="scss">
.register-form {
  position: relative;
  min-height: 296px;
  max-width: 300px;

  .v-card {
    min-height: 262px;
  }

  .v-alert {
    position: relative;
    width: 100%;
  }
}
</style>
